export function redirectToMerchant(url) {
  if (url) {
    window.location.assign(url);
  }
}
